import { useState, useEffect } from 'react';

/**
 * Hook that rotates through a list of placeholder strings.
 * Pauses rotation when the document is hidden (tab not active).
 */
export const useRotatingText = (placeholders: ReadonlyArray<string>): string => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (placeholders.length <= 1) {
      return;
    }

    const intervalId = setInterval(() => {
      if (!document.hidden) {
        setCurrentIndex(prevIndex => (prevIndex + 1) % placeholders.length);
      }
    }, 3000);

    return () => clearInterval(intervalId);
  }, [placeholders.length]);

  return placeholders[currentIndex] ?? placeholders[0] ?? '';
};
